import { render, staticRenderFns } from "./AdminAccountEmail.vue?vue&type=template&id=208910cf&"
import script from "./AdminAccountEmail.vue?vue&type=script&lang=js&"
export * from "./AdminAccountEmail.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccountEmail.vue?vue&type=style&index=0&id=208910cf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports